import React from "react"
import Modal from "react-modal"
import {
  FacebookIcon,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share"

import { WhiteAppButton } from "../../buttons"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: "27px",
    borderColor: "#D1D5DB",
  },
}

const ShareArticleModal: React.FC<{
  isOpen: boolean
  onAfterOpen?: () => void
  onRequestClose: () => void
  quote?: string
}> = ({ isOpen, onAfterOpen, onRequestClose, quote }) => {
  if (!window) return null
  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div style={{ width: "250px" }}>
        <h1 className="text-site-blue-dark text-center mt-2">
          Share article via
        </h1>

        <div className="flex items-center justify-center flex-wrap mt-4">
          <div className="mr-2">
            <FacebookShareButton url={window.location.href} quote={quote}>
              <FacebookIcon size={40} round={true} />
            </FacebookShareButton>
          </div>

          <div className="mr-2">
            <WhatsappShareButton url={window.location.href} title={quote}>
              <WhatsappIcon size={40} round={true} />
            </WhatsappShareButton>
          </div>

          <div>
            <TwitterShareButton url={window.location.href} title={quote}>
              <TwitterIcon size={40} round={true} />
            </TwitterShareButton>
          </div>
        </div>
        <div className="flex items-center justify-center">
          <WhiteAppButton
            title={<span className="text-red-600 text-sm">Cancel</span>}
            onClick={onRequestClose}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ShareArticleModal
